<template>
    <v-app :dark="darkMode"
           id="inspire"
           :class="[{
		'box-layout': boxLayout,
		'collapse-sidebar': collapseSidebar,
		'rtl-layout': rtlLayout
	}]">
        <router-view :auth="auth" :authenticated="authenticated"></router-view>
        <notifications position="center"
                       animation-type="velocity">
            <!--<template slot="body" slot-scope="props">
                <div>
                    <a class="title">
                        {{props.item.title}}
                    </a>
                    <a class="close" @click="props.close">
                        <i class="fa fa-fw fa-close"></i>
                    </a>
                    <div v-html="props.item.text">
                    </div>
                </div>
            </template>-->
        </notifications>
    </v-app>
</template>
<script>
    import { mapGetters } from "vuex";

    import AuthService from "./auth/AuthService";

    const auth = new AuthService();

    const { login, logout, authenticated, authNotifier } = auth;

    export default {
        data() {
            authNotifier.on("authChange", authState => {
                this.authenticated = authState.authenticated;
            });
            return {
                auth,
                authenticated,
                animation: {
                    enter: {
                        opacity: [1, 0],
                        translateX: [0, -300],
                        scale: [1, 0.2]
                    },
                    leave: {
                        opacity: 0,
                        height: 0
                    }
                }
            };
        },
        mounted() {
            if (
                this.selectedLocale.locale === "he" ||
                this.selectedLocale.locale === "ar"
            ) {
                this.$store.dispatch("rtlLayout");
            }
        },
        computed: {
            ...mapGetters([
                "darkMode",
                "collapseSidebar",
                "boxLayout",
                "rtlLayout",
                "selectedLocale"
            ])
        }
    };
</script>
<style>

    .vue-notification {
        padding: 20px;
        margin: 0 5px 5px;
        font-size: 18px;
        color: #ffffff;
        background: #44A4FC;
        border-left: 5px solid #187FE7;
        
        
        
    /*&.error {
        background: #E54D42;
        border-left-color: #B82E24;
    }

    &.success {
        background: #68CD86;
        border-left-color: #42A85F;
    }*/
    }

        .vue-notification.warning {
            background: #ffb648;
            border-left-color: red !important;
            border:0px 0px 0px 2px solid red !important;
        }
</style>